/**
 * Who a story about the two of you was told with, on this phone only.
 *
 * A Story About You Two keeps the friend's name off the post (Exercise.tsx
 * postDeal), so when its storyboard dries — often after you have left the
 * darkroom and it waits on Home — nothing on the server can say who to send it
 * to. This is that memory: the post id, the name you typed, and whether you
 * have sent it yet.
 */
const KEY = 'kindling.friendStories';

interface FriendStory { name: string; sentAt?: number }

function all(): Record<string, FriendStory> {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}') as Record<string, FriendStory>; } catch { return {}; }
}
function save(map: Record<string, FriendStory>): void {
  // the newest forty are plenty: this is for the last few stories, not an address book
  const kept = Object.fromEntries(Object.entries(map).slice(-40));
  try { localStorage.setItem(KEY, JSON.stringify(kept)); } catch { /* private mode */ }
}

export function rememberFriendStory(postId: string, name: string): void {
  const n = name.trim().slice(0, 40);
  if (!postId || !n) return;
  const map = all();
  map[postId] = { ...map[postId], name: n };
  save(map);
}

export function friendOfStory(postId?: string): FriendStory | null {
  if (!postId) return null;
  return all()[postId] ?? null;
}

export function markFriendStorySent(postId: string): void {
  const map = all();
  if (!map[postId]) return;
  map[postId] = { ...map[postId], sentAt: Date.now() };
  save(map);
}
